const { onsiteDrugs } = require('@/api/fullyused')
import helpers from '../../helpers'

export default {
  'entityName': 'fullyused_has_drug',
  'title': 'Fully used drug',
  id: ['fullyused_id', 'drug_id', 'lotto', 'label'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'drug_id',
    'descending': true
  },
  'fields': [
    {
      'value': 'drug_id',
      'text': 'Drug',
      // reference: 'siteresponse_has_drug',
      list: (entity, search, item) => onsiteDrugs(search, item.protocol_id, item.site_id),
      'type': 'autocomplete',
      'title': 'drug.name',
      id: 'drug.id',
      subtitle: ( { drug } ) => `${drug.packaging} (${drug.dose}${drug.measure_unit})`,
      table: true,
      render: ({drug}) => `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})`,
      validators: ['required'],
      small: true
    },
    {
      value: 'lotto',
      text: 'Batch number',
      title: 'lotto',
      subtitle: item => `${item.n_pieces} / ${item.expiration}`,
      list: (entity, search, item) =>  onsiteDrugs(search, item.protocol_id, item.site_id, item.drug_id),
      render: item => item.lotto,
      table: true,
      id: 'lotto',
      deps: ['drug_id'],
      type: 'autocomplete',
      readonly: item => !item.drug_id,
      small: true,
      validators: ['required']
    },
    {
      value: 'site_id',
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.site_id || null,
      type: 'hidden'
    },
    {
      value: '_n_pieces',
      deps: ['lotto'],
      type: 'hidden',
      default: (item, args, selected) => selected && selected.n_pieces
    },
    {
      value: 'expiration',
      small: true,
      text: 'Expiration',
      table: true,
      type: 'text',
      readonly: true,
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.expiration
    },
    {
      full: true,
      "value": "_original_serials",
      text: 'Available Serials',
      deps: ['lotto', 'drug_id'],
      default: (item, args, selected) => selected && selected.serials,
      visible: item => !!item._original_serials && item.lotto,
      readonly: true
    },
    {
      value: '_serials',
      full: true,
      text: 'Fully used serials',
      type: 'textarea',
      deps: ['lotto', 'drug_id', '_original_serials'],
      default: item => item._original_serials,
      visible: item => item.lotto && !!item._original_serials,
      validators: ['required','serials',
      (field, value, item) => {
        if (!item._original_serials) return true
        let ret = helpers.subtractSerials(value, item._original_serials)

        // ret = helpers.subtractSerials(value, ret)

        if (ret.length) {
          let notAvailable = helpers.compatSerials(ret)
          return `Serials ${notAvailable} not available`
        }
        return true
      }
    ]
    },
    {
      value: 'serials',
      type: 'hidden',
      deps: ['_serials'],
      default: item => item._serials && helpers.compatSerials(helpers.explodeSerials(item._serials))
    },
    {
      value: '_n_available_pieces',
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.n_pieces,
      visible: false,
    },    
    {
      'value': 'n_pieces',
      'text': 'Quantity',
      'type': 'number',
      deps: ['serials'],
      default: item => item._original_serials ? helpers.nSerials(item.serials) : item._n_pieces,
      'table': {
        'sortable': true,
        'filter': false
      },
      render: item => item.n_pieces + (item.serials && ' (' + item.serials.replaceAll(',', ', ') + ')'),
      readonly: item => !item.drug_id || !!item._original_serials,
      'validators': [
        'required',
        'number',
        (field, value, item) => value <= item._n_available_pieces || `Should be <= of available pieces (${item.n_pieces} > ${item._n_available_pieces})`,
        (field, value) => value >= 0 || `Only values greater than or equal to zero are allowed.`
      ]
    },
  ],
  actions: ['remove']
}
